import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { database } from "../../lib";
import { Formulario } from "../../types";
import { AtividadesService } from "../atividades";

const FormularioCollection = collection(database, "pesquisa");

export class FormularioServiceClass {
  private static _instance: FormularioServiceClass;

  static getInstace(): FormularioServiceClass {
    if (!this._instance) {
      this._instance = new FormularioServiceClass();
    }
    return this._instance;
  }

  async addForm(data: Formulario) {
    try {
      const docRef = await addDoc(FormularioCollection, {
        ...data,
        createdAt: serverTimestamp(),
      });

      // Atualize o documento recém-criado para definir o campo 'id'
      await updateDoc(docRef, {
        id: docRef.id,
      });
    } catch (err) {
      console.log(err);
    }
  }

  async getPesquisa(data: string): Promise<Formulario | undefined> {
    try {
      const docRef = doc(FormularioCollection, data);
      const pesquisa = await getDoc(docRef);

      return pesquisa.data() as Formulario;
    } catch (err) {
      console.log(err);
    }
  }

  async getPesquisas(): Promise<Formulario[] | undefined> {
    try {
      const pesquisaQuery = query(
        FormularioCollection,
        orderBy("createdAt", "desc")
      );
      const pesquisas = await getDocs(pesquisaQuery);

      return pesquisas.docs.map((doc) => ({
        ...doc.data(),
      })) as Formulario[];
    } catch (err) {
      console.log(err);
    }
  }

  async deletePesquisa(pesquisa: Formulario) {
    try {
      const docRef = doc(FormularioCollection, pesquisa.id);

      await deleteDoc(docRef);

      await AtividadesService.addAtividade(
        `Deletou uma pesquisa: ${pesquisa.name}`
      );
    } catch (err) {
      console.log("Error:", err);
    }
  }
}

export const FormularioService = FormularioServiceClass.getInstace();
